import axios from 'axios';
import { config_headers, URL_API,servicelist } from '../Config';

export const P218GetDataList= async (body) => {
    return new Promise(async (resolve, reject) => {
        try {
            let authorization = await config_headers();
            // console.log('authorization ',authorization.headers);
            await axios.post(URL_API(`${servicelist.BoqService}p_boq_material_report`), body, authorization )
                .then(res => {
                    resolve(res.data);
                }).catch((error)=> {
                    reject(error);
                });
        }
        catch (err) {
            reject(err);
        }
        finally {

        }
    })
}
